import React from 'react'
import { Box, Grid, Paper, Typography, LinearProgress, Tooltip } from '@mui/material'
import { headingBlue, mediumGrey } from '../../assets/colors'

const DistrictTopWidgets = ({ data = {} }) => {
  const {
    totalDistricts = 0,
    districtsWithMaleWorkers = 0,
    districtsWithFemaleWorkers = 0,
    districtHeads = 0,
    deputyDistrictHeads = 0
  } = data

  return (
    <Grid container spacing={1} sx={{
      backgroundColor: "#f3f3f3",
      borderRadius: "0.5rem",
      mb: "0.8rem",
      mt: "0.1rem",
      p: "0.2rem 0.3rem 0.4rem 0.3rem",
      alignItems: "stretch",
      flexShrink: 0
    }}>
      {/* Total Districts */}
      <Grid item xs={12} sm={3}>
        <Paper elevation={0} sx={{ backgroundColor: '#f3f3f3', p: '0.4rem 0.5rem', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography style={{ lineHeight: 1, color: headingBlue, fontSize: '2rem', fontWeight: 'bold' }}>
            {totalDistricts}
          </Typography>
          <Box style={{ width: '95%', margin: '0.4rem auto 0.2rem auto' }}>
            <Tooltip title="100%">
              <LinearProgress
                variant="determinate"
                value={100}
                sx={{
                  width: '100%',
                  height: 8,
                  borderRadius: 5,
                  backgroundColor: mediumGrey || '#e0e0e0',
                  "& .MuiLinearProgress-bar": { backgroundColor: headingBlue }
                }}
              />
            </Tooltip>
          </Box>
          <Typography sx={{ lineHeight: 1.8, color: headingBlue, fontSize: '0.85rem', fontWeight: 600 }}>
            Total Districts
          </Typography>
        </Paper>
      </Grid>

      {/* District with WORKers */}
      <Grid item xs={12} sm={3}>
        <Paper elevation={0} sx={{ backgroundColor: '#f3f3f3', p: '0.4rem 0.5rem', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', alignItems: 'flex-end' }}>
            <Box>
              <Typography variant="caption" sx={{ color: '#1565c0', fontWeight: 'bold', display: 'block', fontSize: '0.75rem' }}>
                Male
              </Typography>
              <Typography style={{ lineHeight: 1, color: '#1565c0', fontSize: '1.7rem', fontWeight: 'bold' }}>
                {districtsWithMaleWorkers}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" sx={{ color: '#d84315', fontWeight: 'bold', display: 'block', fontSize: '0.75rem' }}>
                Female
              </Typography>
              <Typography style={{ lineHeight: 1, color: '#d84315', fontSize: '1.7rem', fontWeight: 'bold' }}>
                {districtsWithFemaleWorkers}
              </Typography>
            </Box>
          </Box>
          <Box style={{ width: '95%', margin: '0.4rem auto 0.2rem auto' }}>
            {(() => {
              const total = totalDistricts || 1;
              const workers = districtsWithMaleWorkers + districtsWithFemaleWorkers;
              const pct = Math.min(100, Math.round((workers / (total * 2)) * 100));
              return (
                <Tooltip title={`${pct}%`}>
                  <LinearProgress
                    variant="determinate"
                    value={pct}
                    sx={{
                      width: '100%',
                      height: 8,
                      borderRadius: 5,
                      backgroundColor: mediumGrey || '#e0e0e0',
                      "& .MuiLinearProgress-bar": { backgroundColor: '#1565c0' }
                    }}
                  />
                </Tooltip>
              );
            })()}
          </Box>
          <Typography sx={{ lineHeight: 1.8, color: '#333333', fontSize: '0.85rem', fontWeight: 600 }}>
            District with WORKers
          </Typography>
        </Paper>
      </Grid>

      {/* District Heads */}
      <Grid item xs={12} sm={3}>
        <Paper elevation={0} sx={{ backgroundColor: '#f3f3f3', p: '0.4rem 0.5rem', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography style={{ lineHeight: 1, color: '#2e7d32', fontSize: '2rem', fontWeight: 'bold' }}>
            {districtHeads}
          </Typography>
          <Box style={{ width: '95%', margin: '0.4rem auto 0.2rem auto' }}>
            {(() => {
              const total = totalDistricts || 1;
              const pct = Math.min(100, Math.round((districtHeads / total) * 100));
              return (
                <Tooltip title={`${pct}%`}>
                  <LinearProgress
                    variant="determinate"
                    value={pct}
                    sx={{
                      width: '100%',
                      height: 8,
                      borderRadius: 5,
                      backgroundColor: mediumGrey || '#e0e0e0',
                      "& .MuiLinearProgress-bar": { backgroundColor: '#2e7d32' }
                    }}
                  />
                </Tooltip>
              );
            })()}
          </Box>
          <Typography sx={{ lineHeight: 1.8, color: '#2e7d32', fontSize: '0.85rem', fontWeight: 600 }}>
            District Heads
          </Typography>
        </Paper>
      </Grid>

      {/* Deputy District Head */}
      <Grid item xs={12} sm={3}>
        <Paper elevation={0} sx={{ backgroundColor: '#f3f3f3', p: '0.4rem 0.5rem', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography style={{ lineHeight: 1, color: '#6a1b9a', fontSize: '2rem', fontWeight: 'bold' }}>
            {deputyDistrictHeads}
          </Typography>
          <Box style={{ width: '95%', margin: '0.4rem auto 0.2rem auto' }}>
            {(() => {
              const total = totalDistricts || 1;
              const pct = Math.min(100, Math.round((deputyDistrictHeads / total) * 100));
              return (
                <Tooltip title={`${pct}%`}>
                  <LinearProgress
                    variant="determinate"
                    value={pct}
                    sx={{
                      width: '100%',
                      height: 8,
                      borderRadius: 5,
                      backgroundColor: mediumGrey || '#e0e0e0',
                      "& .MuiLinearProgress-bar": { backgroundColor: '#6a1b9a' }
                    }}
                  />
                </Tooltip>
              );
            })()}
          </Box>
          <Typography sx={{ lineHeight: 1.8, color: '#6a1b9a', fontSize: '0.85rem', fontWeight: 600 }}>
            Deputy District Head
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default DistrictTopWidgets
